/**
 * @generated SignedSource<<36f907b957de07b394af8077e4fd2565>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemTileBase_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Shipping_viewer" | "ShipsFrom_viewer">;
  readonly " $fragmentType": "ItemTileBase_viewer";
};
export type ItemTileBase_viewer$key = {
  readonly " $data"?: ItemTileBase_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileBase_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "fetchRegionalInfo",
    "variableName": "fetchRegionalInfo"
  },
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  },
  {
    "kind": "Variable",
    "name": "userZipCode",
    "variableName": "userZipCode"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileBase_viewer",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ShipsFrom_viewer"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Shipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "88bb2e8cb2810fab650085989f35db73";

export default node;
